module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signin-container"
  }, [_c('span', {
    staticClass: "md-subheading",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Welcome, Please Login ... ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": _vm.signin
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("  E-mail")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "id": "email",
      "required": "",
      "autofocus": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("  Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "id": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.error) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('p', [_vm._v("There was an error, unable to sign in with those credentials.")])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": ""
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('md-icon', [_vm._v("input")]), _vm._v("   Log In")], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": "",
      "md-flex": "33",
      "md-flex-offset": "33"
    }
  }, [_c('md-button', {
    staticClass: "md-primary"
  }, [_c('md-icon', [_vm._v("supervisor_account")]), _vm._v("   Register")], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-default md-mini"
  }, [_c('md-icon', [_vm._v("info")]), _vm._v("   forgot password")], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-512cc63e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Signin.vue
// module id = 560
// module chunks = 83